
class ParticipantCollection{

  constructor()
  {
        this.collection = [];
  }

  addModel(model) {
      this.collection.push(model);
	  console.log('addModel model-----',model);
	  console.log('addModel-----',this.collection);
  }

  iterateModel() {
      this.collection.forEach((userData)=>{
        console.log('====model data===', userData);
      });
  }

  updateModel(publisherId = null, updateData) {
      for(let i in this.collection)
		{
			if (this.collection[i].id == publisherId || publisherId === null) 
				{
					this.updateParticipantAttributes(this.collection[i], updateData);
				}
		}
  }

  updateParticipantAttributes(modelData, updateData) {
      updateData = JSON.parse(updateData);
      for(let key in updateData){
          modelData[key] = updateData[key];
      }
  }

  getDetailsById(publisherId) {
      let returnData = null;
	  //console.log('getDetailsById-----',this.collection);
	  //console.log('publisherId-----',publisherId);
      this.collection.forEach((userData)=>{
          if (userData.id == publisherId) {
              returnData = userData;
          }
      });

      return returnData;
  }

  getDetailsByEmail(publisherEmail) {
      let returnData = null;

      this.collection.forEach((userData)=>{
          if (userData.email == publisherEmail) {
              returnData = userData;
          }
      });

      return returnData;
  }

  getBroadcasterCount() {
      let broadcasterCount = 0;

      this.collection.forEach((userData)=>{
          if (userData.isVisible === true) {
              broadcasterCount++;
          }
      });

      return broadcasterCount;
  }

  getOnlineUserCount() {
      let onlineCount = 0;

      this.collection.forEach((userData)=>{
          if (userData.currentStatus === 1) {
              onlineCount++;
          }
      });

      return onlineCount;
  }

  getModelData() {
      return this.collection;
  }

  changeAudioMutedState(state) {
      this.collection.forEach((userData)=>{
          if (userData.currentStatus === 1) {
              userData.audioMuted = state;
          }
      });
  }

  getAllBroadcasters() {
      let broadcasters = [];
      broadcasters = this.collection.filter(this.checkIfBroadcaster);
      broadcasters.sort(function(a, b) { return parseInt(a.subscribeTime) - parseInt(b.subscribeTime); });

      return broadcasters;      
  }

  checkIfBroadcaster(userData) {
      return (userData.isVisible === true && userData.currentStatus === 1 && userData.subscribeTime !== null);
  }

  getAllAudience() {
      let audience = [];
      audience = this.collection.filter(this.checkIfAudience);
      audience.sort(function(a, b) { return parseInt(a.subscribeTime) - parseInt(b.subscribeTime); });

      return audience;      
  }

  checkIfAudience(userData) {
      return (userData.isVisible === false && userData.subscribeTime !== null);
  }

  getAllParticipantAudience() {
      let audience = [];
      audience = this.collection.filter(this.checkIfParticipantAudience);
      audience.sort(function(a, b) { return parseInt(a.subscribeTime) - parseInt(b.subscribeTime); });

      return audience;      
  }

  checkIfParticipantAudience(userData) {
      return (userData.isVisible === false && userData.subscribeTime !== null && (userData.videoMuted === null || userData.videoMuted === false));
  }

  getHandraisedList() {
      let raisedHand = [];
      raisedHand = this.collection.filter(this.checkIfRaisedHand);
      raisedHand.sort(function(a, b) { return parseInt(a.raisedHandTime) - parseInt(b.raisedHandTime); });

      return raisedHand;      
  }

  checkIfRaisedHand(userData) {
      return (userData.raisedHand === true);
  }

  getPoorNetworkCount() {
      let poorNetworkCount = 0;

      this.collection.forEach((userData)=>{
          if (userData.hasPoorNetwork === true) {
              poorNetworkCount++;
          }
      });

      return poorNetworkCount;
  }
}

export default ParticipantCollection;
